export enum AlertTypes {
  INFO = 'info',
  SUCCESS = 'success',
  WARNING = 'warning',
  ERROR = 'error'
}

export enum ModalElementTypes {
  ALERT = 'alert',
  MODAL = 'modal'
}

export enum ModalActions {
  SEND_VERIFY_MAIL = 'send_verify_email',
  CLOSE_MODAL = 'close_modal'
}
